export namespace ApprovalObjectStatusCodeConstants {
  export const CURRENT = 'CURRENT';
  export const APPROVED = 'APPROVED';
  export const PENDING = 'PENDING';
  export const REJECTED = 'REJECTED';
  export const EXPIRED = 'EXPIRED';
  export const PROCESSING = 'PROCESSING';
  export const DEACTIVATED = 'DEACTIVATED';
}
